/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesReelController} from "../reel/HorribleHeroesReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {HorribleHerosXSymbol} from "../symbols/HorribleHerosXSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {HorribleHeroesReelSymbol} from "../symbols/HorribleHeroesReelSymbol";
import {HorribleHeroesSymbolM} from "../symbols/HorribleHeroesSymbolM";
import {HorribleHeroesSymbolMX} from "../symbols/HorribleHeroesSymbolMX";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SoundManager} from "../resource/sound/SoundManager";


export class InfectiousPresentation implements GameRoundPresentation {
    public IsXWayExpanded: boolean[];
    public gameAreaSizeAfter: number[] = [];
    private _tl: TimelineLite;
    private nextMode: string;
    private currentMode: string;
    private isAborted: boolean = false;
    private IsInfectiousSymOnReel: boolean[] = [false, false, false, false, false];
    private _XSymbolSize: number[];
    private numberOfExpandSymbolOnReel: number[] = [];
    private expandedSym = "";
    private positionsExpandSyms: number[][] = [];
    private _isXWaysInfected: boolean = false;
    private replacedWithXAlready: boolean[][] = [];
    private replacedWithExpandedXAlready: boolean[][] = [];
    private expandAnimationArr: boolean[][] = [];
    private meltAnimationPlayedArr: boolean[][] = [];
    private _replacedWithExpandedSymAlready: boolean[][] = [];
    private _gameData: HorribleHeroesParsedGameData;
    private _xWaysExpandInfectiousSoundPlayed: boolean[] = [false, false, false, false, false];
    private _xWaysRevealInfectiousSoundPlayed: boolean = false;

    /**
     * @constructs
     */
    constructor() {
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: HorribleHeroesParsedGameData): void {
        this.nextMode = data.nextMode;
        this.currentMode = data.mode;
        this.IsInfectiousSymOnReel = data.IsInfectiousSymOnReel;
        this.positionsExpandSyms = data.getSymbolSizesPos;
        this._XSymbolSize = data.mysterySymbolSizes;
        this.IsXWayExpanded = data.isXWayExpanded;
        this.gameAreaSizeAfter = data.getGameAreaSizeAfter;
        this.numberOfExpandSymbolOnReel = data.numberOfExpandSymbolOnReel;
        this.expandedSym = data.getExpandedSymbol;
        this._isXWaysInfected = data.XWaysInfectiousTriggered;
        this.isAborted = false;
        this._gameData = data;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): Timeline | null {
        this.expandAnimationArr = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
            return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
        });
        this._tl = new TimelineLite({
            onComplete: () => {
                this._tl.pause();
                this._tl.kill();
                this._tl.clear();
            }
        });

        if (this.IsInfectiousSymOnReel.filter(Boolean).length > 0) {
            this._tl.add(() => {
                this.expandAnimationArr = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
                    return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
                });
                this.meltAnimationPlayedArr = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
                    return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
                });
                this.replacedWithExpandedXAlready = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
                    return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
                });
                this.replacedWithXAlready = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
                    return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
                });
                this._replacedWithExpandedSymAlready = ArrayHelper.initArrayWithValues<boolean[]>(5, () => {
                    return ArrayHelper.initArrayWithValues<boolean>(2, () => false)
                });

                // #441
                this._xWaysExpandInfectiousSoundPlayed = [false, false, false, false, false];
                this._xWaysRevealInfectiousSoundPlayed = false;

                this.playInfectiousAnimation(data!, this._tl);
            });
            this._tl.add(() => {}, 1.2);
        } else {
            return null;
        }

        return this._tl;
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: HorribleHeroesParsedGameData): Timeline | null {
        const tl: TimelineLite = new TimelineLite();
        this.isAborted = true;
        tl.add(() => {
            this.playInfectiousAnimation(data!, tl, true);
        });
        tl.timeScale(2);

        return tl;
    }

    /**
     * @playInfectiousAnimation
     * to blink infected symbols
     */
    private playInfectiousAnimation(data: HorribleHeroesParsedGameData, tl: TimelineLite, isAbort?: boolean): TimelineLite {
        isAbort && this._tl.timeScale(2);
        HorribleHeroesGameModuleConfig.reelBackGroundView.updateTotalXWays();

        let reelCount: number = -1;

        for (let reelId: number = 0; reelId < this.IsInfectiousSymOnReel.length; reelId++) {
            const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this.gameAreaSizeAfter[reelId]].height;
            if (this.IsInfectiousSymOnReel[reelId]) {
                reelCount++;
                let mSize = this._XSymbolSize[reelId];
                for (let index = 0; index < data.getInfectiousPos[reelId].length; index++) {
                    const infectedSympos: number = data.getInfectiousPos[reelId][index];
                    let reelSize: number = 4;
                    if (!this.IsXWayExpanded[reelId]) {
                        reelSize = 4 + mSize - 1;
                    }
                    tl.add(() => {
                        !this.replacedWithXAlready[reelId][index] && this.replaceWithX(reelId, infectedSympos, mSize, reelSize);
                        this.replacedWithXAlready [reelId][index] = true;
                    }, reelCount * 0.1);
                    tl.add(() => {
                        !this.expandAnimationArr[reelId][index] && this.expandInfectedSymbols(reelId, index, mSize, infectedSympos, symbolHeight, data);
                        this.expandAnimationArr [reelId][index] = true;
                    }, (reelCount * 0.1) + 0.2);
                    tl.add(() => {
                        !this.replacedWithExpandedXAlready[reelId][index] && this.replacingExpandedX(reelId, index, mSize, infectedSympos);
                        this.replacedWithExpandedXAlready[reelId] [index] = true;
                    }, reelCount * 0.1 + 0.5);

                    tl.add(() => {
                        !this.meltAnimationPlayedArr[reelId][index] && this.playRevealAnimation(reelId, index, mSize);
                        this.meltAnimationPlayedArr[reelId][index] = true;
                    }, reelCount * 0.1 + 0.7);
                    tl.add(() => {
                        !this._replacedWithExpandedSymAlready[reelId][index] && this.replaceWithExpandedSymbols(reelId, index, mSize, infectedSympos, data);
                        this._replacedWithExpandedSymAlready[reelId] [index] = true;
                    }, reelCount * 0.1 + 0.9);
                    tl.add(() => {
                        HorribleHeroesGameModuleConfig.symbolWinAnimation.resetExpandingAnimation();
                    }, reelCount * 0.1 + 1.3);
                }
            }
        }
        return tl;
    }

    /**
     * @inheritDoc to expand  infected Symbols
     * @param reelId - reelIndex where Scatter appears
     * @param symbolHeight - symbolHeight after reels expands
     * @param infectedSympos - position of infected sym
     * @param mSize - expansionSize
     * @param data HorribleHeroesParsedGameData
     * @param index Index of symbol
     */
    private expandInfectedSymbols(reelId: number, index: number, mSize: number, infectedSympos: number, symbolHeight: number, data: HorribleHeroesParsedGameData): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let stackPosY: number = 0;
        let symPos: number = infectedSympos;
        let lastSymIndex: number = data!.getGameAreaSizeAfter[reelId] - mSize;
        if (mSize == 2) {
            stackPosY = ((infectedSympos + 1) * symbolHeight);
        } else {
            stackPosY = ((infectedSympos + 1) * symbolHeight) + symbolHeight / 2;
        }
        let currentHeight = 147;
        let shiftY = Helper.getSymbolPositionsOnReelArea(reelId, infectedSympos)[1] - stackPosY;
        if (this.IsXWayExpanded[reelId] || index == 1) {
            currentHeight = HorribleHeroesReelController.SYM_SIZE[4 + mSize - 1].height;
            /*one symbol is already expanded on reel so we will expand from 117.6 ==>symbolH*mSize */
            if (index == 1) {
                currentHeight = HorribleHeroesReelController.SYM_SIZE[4].height;
                /*both symbol expand parallel so we will expand from 148 ==>symbolH*mSize */
                if (mSize == 2) {
                    stackPosY = ((infectedSympos + mSize) * symbolHeight);
                } else {
                    stackPosY = ((infectedSympos + mSize) * symbolHeight) + symbolHeight / 2;
                }
            }
            shiftY = Reels.getSymbol(reelId, infectedSympos)!.y - stackPosY;
        }
        /*#348 #349 #347*/
        if (index == 0) {
            tl.add(this.adjustOtherSymbols(reelId, infectedSympos, symbolHeight, mSize), 0)
        }
        (<HorribleHerosXSymbol>Reels.getSymbol(reelId, infectedSympos))!.setMayhemMode(this._gameData.isSuperActivatedSpin && !this._gameData.superFSTriggered);
        (<HorribleHerosXSymbol>Reels.getSymbol(reelId, infectedSympos))!.playExpandingAnimation(symbolHeight, mSize, shiftY, symPos, currentHeight, lastSymIndex);

        !this.isAborted && (<HorribleHerosXSymbol>Reels.getSymbol(reelId, infectedSympos))!.quickExpansion(1.5); //#227
        // infected Xways should expand faster;
        this.isAborted && (<HorribleHerosXSymbol>Reels.getSymbol(reelId, infectedSympos))!.quickExpansion();
        return tl;
    }

    /**
     * @inheritDoc to expand Different reel Symbols
     * @param reelId - reelIndex where Scatter appears
     * @param infectedSympos - position of infected sym
     * @param symbolHeight - symbolHeight after reels expands
     * @param mSize - expansionSize
     */
    private adjustOtherSymbols(reelId: number, infectedSympos: number, symbolHeight: number, mSize: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let adjustinSymABove: boolean = false;
        let wildID: number = -1;
        this._gameData.getNonInfectedXWaysPos[reelId].forEach((symId, index) => {
            const sym: StateReelSymbol = (Reels.getSymbol(reelId, symId)!);
            if (symId < infectedSympos) {
                adjustinSymABove = true;
            }
            let xpos: number = this._gameData.XSymbolPositions[reelId];
            if (xpos > -1 && symId > xpos) {
                wildID = symId + 1 - mSize;
            } else {
                wildID = symId;
            }
            const adjustingSymId: number = this._gameData.getNonInfectedPos[reelId][index];
            if (this._gameData.getEvaluatedArea()[reelId][wildID] === "W") {
                //#366
                tl.add(this.adjustStickyWild(reelId, wildID + 1, infectedSympos, mSize, symbolHeight, adjustingSymId), 0);
            }
            tl.add((sym! as HorribleHeroesReelSymbol)!.adjustSize(symbolHeight, adjustingSymId, 0.15), 0);
        });
        if (this._gameData.isXWayExpanded[reelId]) {
            const symId: number = this._gameData.XSymbolPositions[reelId];
            const adjustingSymId: number = symId + mSize - 1;
            let adjustedSymIDX: number = this._gameData.getSymbolSizesPos[reelId][0] + 1;
            let adjustingMPosY: number = 0;
            const sym: StateReelSymbol = (Reels.getSymbol(reelId, symId)!);
            if (mSize == 2) {
                adjustingMPosY = ((adjustedSymIDX) * symbolHeight);
            } else {
                adjustingMPosY = ((adjustedSymIDX) * symbolHeight) + symbolHeight / 2;
            }
            const shiftY: number = sym!.y - adjustingMPosY;
            if (sym!.symName.indexOf("M") > -1) {
                if (sym!.symName.indexOf("MX") > -1) {
                    tl.add((sym! as HorribleHeroesSymbolMX)!.animateStackSymbol(symbolHeight, adjustingSymId, shiftY), 0);
                } else {
                    tl.add((sym! as HorribleHeroesSymbolM)!.animateStackSymbol(symbolHeight, adjustingSymId, shiftY), 0);
                }
            } else {
                for (let royalSymID: number = symId; royalSymID < symId + mSize; royalSymID++) {
                    if (infectedSympos < royalSymID) {
                        adjustedSymIDX = royalSymID + mSize - 1;
                    } else {
                        adjustedSymIDX = royalSymID;
                    }

                    const sym: StateReelSymbol = (Reels.getSymbol(reelId, royalSymID)!);
                    tl.add((sym! as HorribleHeroesReelSymbol)!.adjustSize(symbolHeight, adjustedSymIDX, 0.15), 0);
                }
            }
        }
        return tl;
    }

    private replacingExpandedX(reelId: number, index: number, mSize: number, infectedSympos: number): void {
        let fReelSize: number = this.gameAreaSizeAfter[reelId];
        if (this.numberOfExpandSymbolOnReel[reelId] > 1 && (this.IsXWayExpanded[reelId] || index == 1)) {
            (<HorribleHeroesReelController>Reels.getReel(reelId)).addExtraExpandingSymbols("X", mSize, infectedSympos, fReelSize, this.positionsExpandSyms, this.IsXWayExpanded[reelId]);
        } else {
            if (index == 0) {
                fReelSize = 4 + mSize - 1;
            }
            (<HorribleHeroesReelController>Reels.getReel(reelId)).addExpandingSymbols("X", mSize, infectedSympos, fReelSize, true);
        }
    }

    private replaceWithExpandedSymbols(reelId: number, index: number, mSize: number, infectedSympos: number, data: HorribleHeroesParsedGameData): void {
        let fReelSize: number = this.gameAreaSizeAfter[reelId];
        if (this.numberOfExpandSymbolOnReel[reelId] > 1 && (this.IsXWayExpanded[reelId] || index == 1)) {
            (<HorribleHeroesReelController>Reels.getReel(reelId)).addExtraExpandingSymbols(this.expandedSym, mSize, infectedSympos, fReelSize, this.positionsExpandSyms, true)
        } else {
            if (index == 0) {
                fReelSize = 4 + mSize - 1;
            }
            (<HorribleHeroesReelController>Reels.getReel(reelId)).conversionXwaySym(this.expandedSym, mSize, infectedSympos, fReelSize)
        }

        // #441
        if (!this._xWaysRevealInfectiousSoundPlayed) {
            this._xWaysRevealInfectiousSoundPlayed = true;
            SoundManager.playXWaysRevealInfectious();
        }
    }

    private playRevealAnimation(reelId: number, index: number, mSize: number): void {
        const isMayhemMode: boolean = this._gameData.isSuperActivatedSpin && !this._gameData.superFSTriggered;
        let symId: number = this.positionsExpandSyms[reelId][0];
        if (this.numberOfExpandSymbolOnReel[reelId] > 1) {
            if (this.IsXWayExpanded[reelId] || index == 1) {
                symId = this.positionsExpandSyms[reelId][1];
            }
        }
        const revealAnim: TimelineLite = HorribleHeroesGameModuleConfig.symbolWinAnimation.revealAnimation(reelId, symId, mSize, this.gameAreaSizeAfter[reelId], this._isXWaysInfected, index, isMayhemMode);
        revealAnim.play();
    }

    private replaceWithX(reelId: number, infectedSympos: number, mSize: number, reelSize: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.add((<HorribleHeroesReelController>Reels.getReel(reelId)).replaceWithInfectedX("X", infectedSympos + 1, mSize, reelSize, this.isAborted));

        // #441
        if (!this._xWaysExpandInfectiousSoundPlayed[reelId]) {
            this._xWaysExpandInfectiousSoundPlayed[reelId] = true;
            SoundManager.playXWaysExpandInfectious();
        }

        return tl;
    }

    private adjustStickyWild(reelId: number, symId: number, positionStopId: number, mSize: number, symbolHeight: number, adjustingSymId: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const posY: number = ((adjustingSymId) * symbolHeight) + symbolHeight / 2;
        tl.add(HorribleHeroesGameModuleConfig.stickyWilds.onSymHeightChange(reelId, symId, mSize, this.gameAreaSizeAfter[reelId], posY));
        return tl;
    }
}